(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collapsible-text"] && !Shopify.designMode) return;
  try {
    class CollapsibleTextComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.content = this.querySelector('.collapsible-text-content');
      this.button = this.querySelector('.collapsible-text-button-wrapper');
      this.buttonText = this.button.querySelector('button');
      
      if (!this.button || !this.content) return;

      this.showText = this.buttonText.getAttribute('data-show-text');
      this.hideText = this.buttonText.getAttribute('data-hide-text');
      this.isExpanded = false;

      this.checkIfButtonNeeded();
      this.setupEventListeners();
    }

    checkIfButtonNeeded() {
      const contentHeight = this.content.scrollHeight;
      const previewHeight = this.content.getAttribute('data-content-height');
      
      if (contentHeight <= previewHeight) {
        this.button.style.display = 'none';
        this.content.classList.remove('collapsed');
      }
    }

    setupEventListeners() {
      this.button.addEventListener('click', () => {
        this.toggleContent();
      });
    }

    toggleContent() {
      this.isExpanded = !this.isExpanded;
      
      if (this.isExpanded) {
        this.content.classList.remove('collapsed');
        this.content.classList.add('expanded');
        this.buttonText.textContent = this.hideText;
        this.button.setAttribute('aria-expanded', 'true');
      } else {
        this.content.classList.remove('expanded');
        this.content.classList.add('collapsed');
        this.buttonText.textContent = this.showText;
        this.button.setAttribute('aria-expanded', 'false');
      }
    }
  }
  if (!customElements.get('collapsible-text-component')) customElements.define('collapsible-text-component', CollapsibleTextComponent);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-cart-guard"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cp-cart-guard')) customElements.define('cp-cart-guard',class extends HTMLElement{
  connectedCallback(){
    if(this.initialized)return;this.initialized=true;
    this.$=s=>this.querySelector(s);this.copy=JSON.parse(this.$('[data-guard-copy]').textContent);
    this.state=JSON.parse(this.$('[data-cp-cart-state]').textContent);this.threshold=Number(this.dataset.freightThresholdLb)*453.59237;
    this.seen=new Set();this.bypass=false;this.checking=false;
    this.querySelectorAll('[data-close]').forEach(button=>button.addEventListener('click',()=>button.closest('dialog').close()));
    this.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('close',()=>{if(dialog===this.$('[data-freight]'))this.resume=null;}));
    this.$('[data-continue]').addEventListener('click',()=>{const resume=this.resume;this.resume=null;this.$('[data-freight]').close();if(resume)this.proceed(resume);});
    document.addEventListener('click',event=>{
      if(this.contains(event.target)||this.bypass)return;
      const button=event.target.closest('button[name="checkout"],input[name="checkout"],a[href]');
      if(!button)return;
      const isLink=button.tagName==='A' && new URL(button.href,location.href).origin===location.origin && /\/checkout\/?$/.test(new URL(button.href).pathname);
      if(button.tagName==='A'&&!isLink)return;
      if(button.disabled)return;
      if(button.form&&!button.form.reportValidity())return;
      event.preventDefault();event.stopImmediatePropagation();
      this.check(()=>button.click());
    },true);
    document.addEventListener('submit',event=>{
      if(this.bypass)return;
      const form=event.target, submitter=event.submitter;
      if(submitter?.name!=='checkout'&&!/\/checkout\/?$/.test(new URL(form.action,location.href).pathname))return;
      event.preventDefault();event.stopImmediatePropagation();
      this.check(()=>form.requestSubmit(submitter || undefined));
    },true);
    this.schedule=()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.refresh(true).catch(()=>{}),250);};
    ['cart:updated','cart-update','cart:refresh','cp:cart-updated','GiftWrapUpdateEvent'].forEach(name=>document.addEventListener(name,this.schedule));
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,this.schedule);
    document.addEventListener('quantity-selector:update',()=>{this.changedAt=Date.now();this.schedule();});
    document.addEventListener('change',event=>{if(event.target.matches('input[name="updates[]"],input[data-cart-line]')){this.changedAt=Date.now();this.schedule();}});
    this.applyState(location.pathname.replace(/\/$/,'')===this.dataset.cartUrl.replace(/\/$/,''));
  }
  signature(){return JSON.stringify([this.state.weight,this.state.items.map(i=>[i.key,i.quantity])]);}
  invalid(){const totals=new Map();for(const item of this.state.items){if(item.restricted){const current=totals.get(item.id)||{...item,quantity:0};current.quantity+=item.quantity;totals.set(item.id,current);}}return [...totals.values()].filter(i=>i.quantity<100||i.quantity>499);}
  async refresh(show){
    const response=await fetch(`${this.dataset.cartUrl}?section_id=cp-cart-state&_cp=${Date.now()}`,{cache:'no-store'});
    if(!response.ok)throw new Error(this.copy.error);
    const html=new DOMParser().parseFromString(await response.text(),'text/html');
    const node=html.querySelector('[data-cp-cart-state]');if(!node)throw new Error(this.copy.error);
    this.state=JSON.parse(node.textContent);this.applyState(show);
  }
  applyState(show){
    const invalid=this.invalid();
    document.documentElement.classList.toggle('cp-guard-wallets-blocked',invalid.length>0);
    const restricted=new Set(this.state.items.filter(i=>i.restricted).map(i=>String(i.id)));
    document.querySelectorAll('input[data-quantity-variant-id]').forEach(input=>{if(restricted.has(input.dataset.quantityVariantId)){input.min='100';input.max='499';input.step='1';}});
    if(show&&this.dataset.freightEnabled==='true'&&this.state.weight>this.threshold&&!invalid.length&&!this.seen.has(this.signature())&&!this.checking&&!this.$('[data-freight]').open){this.showFreight(null);}
  }
  showFreight(resume){this.resume=resume || (()=>{const button=document.querySelector('button[name="checkout"]:not([disabled])');if(button)button.click();else location.assign(`${this.dataset.cartUrl}/../checkout`);});this.seen.add(this.signature());if(!this.$('[data-freight]').open)this.$('[data-freight]').showModal();}
  proceed(resume){this.bypass=true;try{resume();}finally{this.bypass=false;}}
  async check(resume){
    if(this.checking)return;this.checking=true;
    try{
      if(this.changedAt&&Date.now()-this.changedAt<700)await new Promise(resolve=>setTimeout(resolve,700));
      await this.refresh(false);
      const invalid=this.invalid();
      if(invalid.length){
        this.$('[data-quantity-message]').textContent=this.copy.limit;
        this.$('[data-invalid-items]').replaceChildren(...invalid.map(item=>{const li=document.createElement('li');li.textContent=`${item.title} (${item.quantity})`;return li;}));
        this.$('[data-quantity-dialog]').showModal();return;
      }
      if(this.dataset.freightEnabled==='true'&&this.state.weight>this.threshold&&!this.seen.has(this.signature()))this.showFreight(resume);
      else this.proceed(resume);
    }catch(error){this.$('[data-quantity-message]').textContent=this.copy.error;this.$('[data-invalid-items]').replaceChildren();this.$('[data-quantity-dialog]').showModal();}
    finally{this.checking=false;}
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cp-sale-link"] && !Shopify.designMode) return;
  try {
    (() => {
  const update=()=>document.querySelectorAll('[data-cp-sale-schedule]').forEach(link=>{
    const now=Date.now(), start=link.dataset.start?Number(link.dataset.start)*1000:-Infinity, end=link.dataset.end?Number(link.dataset.end)*1000:Infinity;
    link.hidden=!(link.dataset.designMode==='true'||(link.dataset.enabled==='true'&&link.dataset.hasProducts==='true'&&now>=start&&now<end));
  });
  update();setInterval(update,30000);document.addEventListener('shopify:section:load',update);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["multi-level-category"] && !Shopify.designMode) return;
  try {
    var first = true;

  function getCategories(root) {
    var result = [];
    var lis = root.querySelectorAll(':scope > li');
    lis.forEach(function (li) {
      var link = li.querySelector(':scope > a');
      var childrenUl = li.querySelector(':scope > ul');
      var node = {
        link: link ? link.getAttribute('href') : '',
        title: link ? link.innerHTML : '',
        children: childrenUl ? getCategories(childrenUl) : [],
      };
      result.push(node);
    });
    return result;
  }

  function setActive() {
    var result = [];
    var curLi = document.querySelector('nav#navPages > ul .active');
    if (!curLi || curLi.parentElement == null) return false;
    var index = Array.from(curLi.parentElement.children).indexOf(curLi);
    if (index === -1) return false;
    result.push(index);

    curLi = curLi.parentElement.parentElement;
    if (curLi && curLi.id !== 'navPages') {
      index = Array.from(curLi.parentElement.children).indexOf(curLi);
      result.push(index);
      curLi = curLi.parentElement.parentElement;
      if (curLi && curLi.id !== 'navPages') {
        index = Array.from(curLi.parentElement.children).indexOf(curLi);
        result.push(index);
      }
    }
    return result;
  }

  function buildSelect(level, level_List) {
    for (var i = level; i <= 4; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (ul) {
        ul.querySelectorAll('li[data-value]').forEach((li) => li.remove());
      }
    }
    var container = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!container) return;
    for (var i = 0; i < level_List.length; i++) {
      var li = document.createElement('li');
      li.setAttribute('data-value', i);
      li.textContent = level_List[i].title.trim();
      li.addEventListener(
        'click',
        (function (lvl, idx) {
          return function () {
            changeOption(lvl, idx);
          };
        })(level, i)
      );
      container.appendChild(li);
    }
  }

  function changeOptionAll(level) {
    var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
    if (!ul) return;
    ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
    var label = document.querySelector('#multi-category_select-level-' + level).previousElementSibling;
    label.innerHTML = select_option;
  }

  function changeOption(level, num) {
    if (num != null) {
      var redirect = false;
      var selector = '#multi-category_select-level-' + level + ' ul li[data-value="' + num + '"]';
      var activeLi = document.querySelector(selector);
      if (activeLi && !activeLi.classList.contains('active')) {
        redirect = true;
      }
      var ul = document.querySelector('#multi-category_select-level-' + level + ' ul');
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
      ul.querySelectorAll('li').forEach(function (li) {
        if (li.getAttribute('data-value') == num) {
          li.classList.add('active');
          document.querySelector('#multi-category_select-level-' + level).previousElementSibling.textContent =
            li.textContent;
        }
      });

      resetDrop(level);

      var level_List = list;
      for (var i = 1; i <= level; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          var index = parseInt(active.getAttribute('data-value'));
          if (level_List[index] !== undefined) {
            level_List = level_List[index].children;
          }
        }
      }

      if (level == 3 && redirect == true) {
        document.querySelector('#multi-category_select-browse').click();
      }

      level = parseInt(level) + 1;
      buildSelect(level, level_List);

      if (level_List.length && first == false) {
        var loading = document.querySelector('.multi-category_filter .loading');
        loading.style.display = 'block';
        setTimeout(function () {
          document.querySelector('#multi-category_select-level-' + level).classList.add('open');
          loading.style.display = 'none';
        }, 300);
      }
    }
  }

  function resetDrop(num) {
    for (var i = num + 1; i <= list.length; i++) {
      var ul = document.querySelector('#multi-category_select-level-' + i + ' ul');
      if (!ul) continue;
      var select_option = ul.querySelector('li:nth-child(1)') ? ul.querySelector('li:nth-child(1)').innerHTML : '';
      var label = document.querySelector('#multi-category_select-level-' + i).previousElementSibling;
      label.innerHTML = select_option;
      ul.innerHTML = '<li onclick="changeOptionAll(' + i + ')">' + select_option + '</li>';
    }
  }

  var list = getCategories(document.querySelector('nav#navPages > ul'));

  function MultiCategory() {
    if (!document.querySelector('.multi-category')) {
      return;
    }

    buildSelect(1, list);

    var level = 1;
    document.cookie = 'multiLevelCategory=; path=/;';

    var cookie = document.cookie.split('; ').find((row) => row.startsWith('multiLevelCategory='));
    if (cookie && cookie.split('=')[1] != '') {
      var active = cookie.split('=')[1].split(',');
      for (var i = 0; i < active.length; i++) {
        changeOption(level, active[i]);
        level++;
      }
      document.querySelector('.multi-category_filter .loading').style.display = 'none';
      document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
    }

    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('da-force-up')) {
        var dropdown = e.target.parentElement.querySelector('.dropdown-up');
        var isOpen = dropdown.classList.contains('open');
        document.querySelectorAll('.dropdown-up').forEach((el) => el.classList.remove('open'));
        if (!isOpen) dropdown.classList.add('open');
      }
    });

    window.addEventListener('click', function (e) {
      var container = document.querySelectorAll('.da-force-up');
      container.forEach(function (el) {
        if (el !== e.target && !el.contains(e.target)) {
          var dropdown = el.nextElementSibling;
          if (dropdown && dropdown.classList.contains('dropdown-up')) {
            dropdown.classList.remove('open');
          }
        }
      });
    });

    document.querySelector('#multi-category_select-browse').addEventListener('click', function () {
      var level_List = list;
      var index = 0,
        url = '';
      var menu = [];
      for (var i = 1; i <= 3; i++) {
        var active = document.querySelector('#multi-category_select-level-' + i + ' ul .active');
        if (active) {
          index = parseInt(active.getAttribute('data-value'));
          if (!isNaN(index)) {
            menu.push(index);
            url = level_List[index].link;
            if (level_List[index].children.length) {
              level_List = level_List[index].children;
            }
          }
        }
      }
      document.cookie = 'multiLevelCategory=' + menu.join(',') + '; path=/; max-age=' + 60 * 60 * 24;
      location.href = url;
    });

    document.querySelector('#multi-category_clear-select').addEventListener('click', function () {
      resetDrop(1);
      var ul = document.querySelector('#multi-category_select-level-1 ul');
      var select_option = ul.querySelector('li:nth-child(1)').innerHTML;
      document.querySelector('#multi-category_select-level-1').previousElementSibling.innerHTML = select_option;
      ul.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    });

    first = false;
  }

  window.addEventListener('load', () => {
    MultiCategory();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["social-share-button"] && !Shopify.designMode) return;
  try {
    class ShareButtonProduct extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        shareButton: this.querySelector('button'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input'),
        content: this.querySelector('.share-button__product'),
        copyButton: this.querySelector('.button-copy')
      };

      if (this.elements.shareButton) {
        this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
      }
      if (this.elements.copyButton) {
        this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      }
    }

    toggleDetails(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();
      if (!this.elements.urlInput) return;

      const url = this.elements.urlInput.getAttribute('data-url');

      this.setProductInfoTop(this.getProductInfoPosition());

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
    }

    copyToClipboard(event) {
      event?.preventDefault && event.preventDefault();
      event?.stopPropagation && event.stopPropagation();

      if (!this.elements.urlInput || this.elements.urlInput.classList.contains('is-copy')) return;

      navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
        if (this.elements.successMessage) {
          this.elements.successMessage.setAttribute('aria-hidden', false);
        }
        this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
        this.elements.urlInput.classList.add('is-copy');

        setTimeout(() => {
          if (this.elements.successMessage) {
            this.elements.successMessage.setAttribute('aria-hidden', true);
          }
        }, 6000);
      });
    }

    closeDetails(event) {
      event?.preventDefault && event.preventDefault();
      if (!this.elements.urlInput) return;
      const url = this.elements.urlInput.getAttribute('data-url');

      if (this.elements.successMessage) {
        this.elements.successMessage.classList.add('hidden');
      }
      this.elements.urlInput.setAttribute('value', url);
      this.elements.urlInput.classList.remove('is-copy');
      this.setProductInfoTop(0);
    }

    getProductInfoPosition() {
      const stickyElement = document.querySelector('.productView-details');
      if (!stickyElement || !stickyElement.parentNode) return 0;

      const stickyRect = stickyElement.getBoundingClientRect();
      const parentRect = stickyElement.parentNode.getBoundingClientRect();

      const topOffset = stickyRect.top - parentRect.top;
      return topOffset;
    }

    setProductInfoTop(top) {
      const productDetails = document.querySelector('.productView-details');
      if (productDetails && productDetails.style) {
        productDetails.style.setProperty('--sticky-top', top + 'px');
      }
    }
  }

  if (!customElements.get('share-button-product')) {
    customElements.define('share-button-product', ShareButtonProduct);
  }
  } catch(e) { console.error(e); }
})();

})();
